import React from "react";
import { Container } from "react-bootstrap";
import { Table } from "../../components/CustomPaginations";
import { tableStyle } from "../ticketModule/variables/ListingVariables";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import MonthlyReimbursementTable from "./MonthlyReimbursementTable";

const ReimbursementTable = (props) => {
	return (
		<Container fluid className="p-0">
			{props.monthlyReimburse ? (
				<MonthlyReimbursementTable
					monthlyReimburse={props.monthlyReimburse}
					viewMonthlyReimburseDetails={
						props.viewMonthlyReimburseDetails
					}
					empDepartment={props.empDepartment}
					menuProps={props.menuProps}
					receiveData={props.receiveData}
					paginateLeft={props.paginateLeft}
					paginateRight={props.paginateRight}
					onMasterCheck={props.onMasterCheck}
					masterChecked={props.masterChecked}
					pageNum={props.pageNum}
					MonthlyReimbursementTableLoader={
						props.MonthlyReimbursementTableLoader
							? props.MonthlyReimbursementTableLoader
							: false
					}
					numberOfItemsPerPage={props.numberOfItemsPerPage}
					getSpecificReimbursementRecord={
						props.getSpecificReimbursementRecord
					}
					pagerData={props.pagerData}
				/>
			) : props.generalReimburse ? (
				<PaginationProvider
					pagination={paginationFactory({
						custom: true,
						totalSize: props.pagerData
							? props.pagerData.TotalCount
							: 0,
						page: props.pageNum,
						sizePerPage: props.numberOfItemsPerPage,
						paginationSize: props.numberOfItemsPerPage,
					})}
				>
					{({ paginationProps, paginationTableProps }) => {
						return (
							<Table
								keyField="tokenNumber"
								columns={
									props.empDepartment === "5"
										? props.columnsForFinance
										: props.columns
								}
								items={props.generalReimburse}
								tableStyle={tableStyle}
								paginationProps={paginationProps}
								paginationTableProps={paginationTableProps}
								defaultSorted={props.defaultSorted}
								pagerData={props.pagerData}
								onTablePageChange={props.handleTableChange}
								tableLoader={
									props.isGeneralReimbLoading
										? props.isGeneralReimbLoading
										: false
								}
								loading={
									props.isGeneralReimbLoading
										? props.isGeneralReimbLoading
										: false
								}
								SearchBar={() => {
									return null;
								}}
								receiveData={(PageSize) => {
									props.receiveData(PageSize);
								}}
								adminPagination={props.empDepartment === "5"}
							/>
						);
					}}
				</PaginationProvider>
			) : null}
		</Container>
	);
};

export default ReimbursementTable;
